<template>
    <div id="registration">
        <Loading v-if="show"></Loading>
        <div class="registration-container">
            <div class="registration_main">
                <div class="registration-banner">
                    <img :src="bannerSrc" alt />
                </div>
                <h2 class="registrationContent-title">
                    <div>{{meetingTitle}}</div>
                </h2>
                <div class="checkin" v-if="action">
					<div v-if="SignupStatusCode==3">
						<div class="checkin-ico checkin-ico-danger">
							<img src="../../assets/danger.png">
							<div class="checkin-ico-div" :class="{'actions':action}"></div>
						</div>
						<div class="checkin-success">
							报名信息待审核
						</div>
					</div>
					<div v-else>
						<div class="checkin-ico checkin-ico-success">
							<img src="../../assets/success.png">
							<div class="checkin-ico-div" :class="{'actions':action}"></div>
						</div>
						<div class="checkin-success">
							恭喜您，签到成功！
						</div>
						<div class="checkin-text">
							欢迎莅临现场
						</div>
					</div>
                </div>
                <div class="registrationContent-form" v-if="action">
                    <div class="formItem">
                        <div class="formItem-title">
                            姓名
                        </div>
                        <div class="formItem-val">
                            {{ checkinDatas.username }}
                        </div>
                    </div>
                    <div class="formItem">
                        <div class="formItem-title">
                            手机
                        </div>
                        <div class="formItem-val">
                            {{ checkinDatas.userphone }}
                        </div>
                    </div>
                </div>
                <!-- <div class="code-wrap" v-if="coderKey">
                    <div class="QR-code">
                        <div id="qrcode"></div>
                    </div>
                    <p>资料领取二维码</p>
                </div> -->
            </div>
        </div>
        <div class="tips-box" v-if="tipsVisible">
            <div class="tips-con">
                <div class="tips-text">
                    {{tipsText}}
                </div>
                <div class="tips-group">
                    <div class="tips-group-btn" @click="sureTips()">
                        确定
                    </div>
                </div>
            </div>
        </div>
		<Nav v-if="fNavShow"></Nav>
        <Footer :footInfo="this.footInfo"></Footer>
    </div>
</template>
<script>
import Loading from '@components/Loading.vue'
import Nav from '../Meeting/components/common/navigation.vue'
import Footer from '@components/Footer.vue'
import publicSignup from '../../lib/signUp.js'
import wxShare from '../../lib/wxShare.js'
import QRCode from 'qrcodejs2'
export default {
    neme: 'scanCheckin',
    components: {
        Footer,
        Loading,
		Nav
    },
    data() {
        return {
            publicSignup: {}, //通用js
            meetingInfo: {}, //会议基本信息
            meetingTitle: '',
            bannerSrc: '',
            show: true,
            currentDate: new Date(),
            params: {
                m: '',
                code: '',
            }, // code唯一标识
            action: false,
            checkinDatas: [],
            tipsVisible: false,
            coderKey: '',
            imgUrl: '',
			footInfo: {
				LogoTxt: '',
				LogoLink: '',
				LogoImg: '',
			},
			fNavShow: true,
			SignupStatusCode: '',
        }
    },
    created() {
        this.params.m = this.$route.query.m
        this.params.code = this.$route.query.code
        this.publicSignup = new publicSignup()
        this.getMeetingInfo()
    },
    mounted() {
        //this.scanCheckinConfig()
        // setInterval(() => {
        //   this.scanCheckinConfig()
        // }, 1000)
    },
    methods: {
        //生成二维码
        qrcode(link) {
          new QRCode('qrcode', {
            width: 154,
            height: 154, // 高度
            text: link, // 二维码内容
            render: 'table', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            correctLevel: QRCode.CorrectLevel.H
          })
        },
        async getMeetingInfo() {
            let opt = {
                m: this.params.m,
                ch: this.$route.query.ch,
            }
            this.meetingInfo = await this.publicSignup.init(opt, this)
            if( this.meetingInfo.Code === 1000){
				this.footInfo.LogoTxt = this.meetingInfo.LogoTxt
				this.footInfo.LogoLink = this.meetingInfo.LogoLink
				this.footInfo.LogoImg = this.meetingInfo.LogoImg
                this.meetingTitle = this.meetingInfo.MeetingTitle
                //获取bnner图路径
                this.bannerSrc = this.meetingInfo.MobileBannerImage
                this.init()
            }
        },
        async init() {
            this.scanCheckinConfig()
        },
        /**
         * @description: 初始化报名信息
         */
        async scanCheckinConfig() {
            let that = this
            const _params = {
                m: this.params.m,
                code: this.params.code
            }
            try {
                const ress = await this.$http.scanCheckin(_params)
                console.log(ress)
                // var ress = {
                //     CurUserEntity: {
                //         muid: 8891,
                //         username: "张三1213456",
                //         userphone: "18514469412",
                //         createtime: "/Date(1596712477000)/",
                //         checktime: "/Date(-62135596800000)/",
                //         userval: [{
                //             value: '18514469412',
                //             text: '手机号'
                //         }, {
                //             value: '张三123456',
                //             text: '姓名1'
                //         },{
                //             value: '22222',
                //             text: '邮箱'
                //         }, {
                //             value: '114',
                //             text: '身份证'
                //         },{
                //             value: '女',
                //             text: '性别'
                //         }, {
                //             value: '',
                //             text: '日期'
                //         }, {
                //             value: '',
                //             text: '下拉框'
                //         }, {
                //             value: '',
                //             text: '下拉框搜索'
                //         }, {
                //             value: '北京市-北京市',
                //             text: '省市'
                //         }],
                //     },
                //     Code: 1000
                // }
                if (ress.Code === 1000) {
                    this.action = true
					this.SignupStatusCode = ress.SignupStatusCode
                    this.checkinDatas = ress.CurUserEntity
                }else if( ress.Code === 7001 || ress.Code === 7002 ){
                    this.tipsText = ress.Msg
                    this.tipsVisible = true 
                }
                if( ress.CoderKey != null && ress.CoderKey != '' && ress.CoderKey ){
                    this.coderKey = true
                    setTimeout(() => {
                        this.qrcode(ress.CoderKey)
                    }, 0)
                }else{
                    this.coderKey = false
                } 
                this.show = false
            } catch (error) {
                console.log(error)
            }
        },
        sureTips(){
            this.$router.push({
                path: '/signup/signupinfo',
                query: this.$route.query,
            })
        },

        // ============
        async initShare(title, desc, link, imgUrl) {
            try {
                const headRes = await this.$http.csData({
                    url: encodeURIComponent(
                        window.location.href.replace(location.hash, '')
                    ),
                })
                const _Wx = new wxShare({
                    opt: headRes,
                })
                _Wx.ready().then((wx) => {
                    _Wx.share(title, desc, link, imgUrl)
                    console.log(wx)
                })
            } catch (err) {
                console.log(err)
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.tips-box{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0,0,0,.5);
    .tips-con{
        position: absolute;
        width: 70%;
        background: #ffffff;
        top: 50%;
        left: 50%;
        z-index: 1000;
        transform: translate(-50%,-50%);
        font-size: 30px;
        text-align: center;
        border-radius: 20px;
        overflow: hidden;
        .tips-text{
            height: 130px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .tips-group{
            display: flex;
            height: 90px;
            border-top: 1px solid #e2e8f0;
            >div{
                flex: 1;
                line-height: 90px;
            }
            >div:last-child{
                // background: #009ffa;
                color: #3b82f6;
            }
        }
    }
}
#registration {
    width: 100%;
    .registration-container {
        padding-bottom: 100px;
        .registration-banner {
            >img {
                width: 100%;
            }
        }
        .registrationContent-title {
            text-align: center;
            width: 100%;
            margin: 1rem auto;
            padding-bottom: 16px;
            border-bottom: 2px solid #3b82f6;

            >div {
                font-size: 1.25rem;
                font-weight: 600;
                padding-bottom: 0.375rem;
                color: #1e293b;
            }
        }
        .checkin{
            text-align: center;
            margin: 50px auto;
			.checkin-ico-success{
				background-color: #67C23A;
			}
			.checkin-ico-danger{
				background-color: #e6a23c;
			}
            .checkin-ico{
                position: relative;
                width: 200px;
                height: 200px;
                border-radius: 100px;      
                margin: 0 auto 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                img{
                    width: 60%;
                }
                .checkin-ico-div{
                    position: absolute;
                    z-index:-1;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    width: 100%;
                    height: 100%;
                    background-color: #67C23A; 
                }
                .actions{
                    animation: opacity .4s linear;
                    -moz-animation: opacity .4s linear;  /* Firefox */
                    -webkit-animation: opacity .4s linear;  /* Safari 和 Chrome */
                    -o-animation: opacity .4s linear;
                }
                @keyframes opacity{
                    0%   { width: 120px; left:0;z-index:1}
                    50%   { width: 60px; left: 60px;}
                    100% { width: 0px; left:120px; z-index:-1}
                }

                @-moz-keyframes opacity /* Firefox */{
                    0%   { width: 120px; left:0;z-index:1}
                    50%   { width: 60px; left: 60px;}
                    100% { width: 0px; left:120px; z-index:-1}
                }

                @-webkit-keyframes opacity /* Safari 和 Chrome */{
                    0%   { width: 120px; left:0;z-index:1}
                    50%   { width: 60px; left: 60px;}
                    100% { width: 0px; left:120px; z-index:-1}
                }

                @-o-keyframes opacity /* Opera */{
                    0%   { width: 120px; left:0;z-index:1}
                    50%   { width: 60px; left: 60px;}
                    100% { width: 0px; left:120px; z-index:-1}
                }
            }
            .checkin-success{
                font-size: 40px;
                color: #1e293b;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .checkin-text{
                font-size: 34px;
                color: #64748b;
            }
        }
        .registrationContent-form {
            width: 80%;
            margin: 0 auto;
            box-shadow: 0 2px 12px rgba(0,0,0,0.04);
            border: 1px solid #e2e8f0;
            border-radius: 20px;
            background-color: #ffffff;
            padding: 15px 0;
            .formItem {
                padding: 0 20px;
                margin: 25px 0;
                display: flex;
                font-size: 28px;
                color: #64748b;
                .formItem-title{
                    width: 150px;
                    font-weight: bold;
                    color: #1e293b;
                    text-align: right;
                    padding-right: 20px;
                }
                .formItem-val{
                    flex: 1;
                    padding: 0 20px;
                }
            }

            .divider {
                font-size: 24px;

                .dividerLine {
                    margin: 20px 0px;
                    border-top: 1px solid #e2e8f0;
                }
            }
        }
        .code-wrap{
            text-align: center;
            margin: 50px auto 0;
            .QR-code{
                display: inline-block; 
                // margin: 0 auto;
                // width: 308px;  
                // height: 308px;   
                box-shadow: 0 2px 12px rgba(0,0,0,0.04);
                border: 1px solid #e2e8f0;
                padding: 15px;
                background: #ffffff;            
            }
            p{
                margin-top: 15px;
                font-size: 28px;
            }
        }
    }
}
</style>
<style type="text/css">
    #app{
        background-color: #ffffff;
    }
</style>